import script from "./AdPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AdPopup.vue?vue&type=style&index=0&id=086467f6&lang=css"

const __exports__ = script;

export default __exports__